import { React, useState } from "react";
import { confirmHandshake as confirmHandshakeUtil } from '../../utils/HandshakeManager';
import { usePasswordAndUserId } from "../../context/AuthContext";
import bs58 from "bs58";

export default function ConfirmRequestMessage({ 
  conversationId,
  message,
  localKeys,
  participants,
}) {
  const [status, setStatus] = useState('init');
  const { password, userId, salt } = usePasswordAndUserId(); 

  const senderB58 = bs58.encode(message.senderViewPublicKey);
  const isSentByMe = senderB58 === bs58.encode(localKeys.viewPublicKey);

  const senderParticipant = participants?.find(
    (p) => bs58.encode(p.identityViewPublicKey) === senderB58
  );

  const alreadyConfirmed = senderParticipant?.keys.status === 'complete' || senderParticipant?.keys.status === 'waiting';

  const confirmHandshake = async () => {
    try {
      setStatus('incoming_confirming');

      await confirmHandshakeUtil({ 
        conversationId,
        contactNextViewPublicKey: senderParticipant.keys.contactNextViewPublicKey,
        contactIdentityViewPublicKey: senderParticipant.identityViewPublicKey,
        sessionKyberPublicKey: message.message.kyberPublicKey,
        // kyberSecret, hierzo
        password, 
        userId, 
        salt,
      });
      setStatus('done');
    } catch (e) {
      console.error("Handshake confirmation failed", e);
      setStatus('error');
    }
  };

  const onDeny = async () => {
    alert('stop!');
  };

  return (
    <div
      style={{
        background: "#222",
        padding: "1rem",
        borderRadius: "8px",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "80%",
        alignSelf: "center",
      }}
    >
      {isSentByMe ? (
        <p style={{ marginBottom: "0.5rem" }}>
          You sent a secure chat request to:
        </p>
      ) : (
        <p style={{ marginBottom: "0.5rem" }}>
          Someone wants to start a secure chat with you:
        </p>
      )}

      {message?.message?.message && (
        <div
          style={{
            backgroundColor: "#333",
            padding: "0.75rem",
            borderRadius: "6px",
            marginBottom: "1rem",
            fontSize: "0.95rem",
            width: "95%",
          }}
        >
          {message.message.message}
        </div>
      )}

      {!isSentByMe && !alreadyConfirmed && (
        <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
          <button
            onClick={confirmHandshake}
            disabled={status === 'incoming_confirming'}
            style={{
              background: "#4e8cff",
              color: "#fff",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              cursor: "pointer",
              opacity: status === 'incoming_confirming' ? 0.6 : 1,
            }}
          >
            {status === 'incoming_confirming' ? "Confirming…" : "Accept Chat Request"}
          </button>
          <button
            onClick={onDeny}
            style={{
              background: "#666",
              color: "#fff",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Block user
          </button>
        </div>
      )}
    </div>
  );
}